module.exports = __webpack_public_path__ + "img/sld_abt_dark.e3f7ecc7.svg";